<template>
    <div class="container">
        <!-- <div style="display:flex;flex-direction: row;width:100%" >
            <div class="img" v-if="showBack">
                <img src="../../../static/images/back.png" @click="back" style="width:15px;height:22px;"/>
            </div>
            <div class="title">
                {{title}}
            </div>
        </div> -->
        <div class="maindiv">
            <div v-show="page === 'caseInput'">
                <caseInput-componet ref="caseInput" ></caseInput-componet>
            </div>
            <div v-show="page === 'inputQrCode'">
                <inputQrCode-componet ref="inputQrCode" ></inputQrCode-componet>
            </div>
        </div>
    </div>
</template>
<script>
import CaseInput from './case-input.vue'
import InputQrCode from './input-qrCode.vue'

export default {
    components:{
        "caseInput-componet": CaseInput,
        "inputQrCode-componet": InputQrCode
    },
    data() {
        return {
            page: 'caseInput',
            title: '案件信息', // 标题
            suitId: null,
            showBack: false
        }
    },
    mounted() {
        this.init()
    },
    methods: {

        // 跳转立案信息填写页面
        init(){
            this.page = 'caseInput'
            this.$refs.caseInput.init()
        },

        // 跳转立案信息填写页面
        goInput(){
            this.page = 'caseInput'
        },

        // 跳转生成二维码页面
        goQrcode(form){
            this.page = 'inputQrCode'
            this.title = '二维码'
            this.showBack = true
            this.$refs.inputQrCode.init(form)
        },

        back(){
            this.page = 'caseInput'
            this.title = '案件信息'
            this.showBack = false
            this.$refs.caseInput.init()
        }
    },
}
</script>
<style scoped>
.container{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* background:#e9e9e9; */
}

.img{
    width: 20px;
    height: 20px;
    margin-left: 10px;
    margin-top: 10px;
}

.title {
    width: 100%;
    font-size: 20px;
    margin-top: 10px;
    text-align: center;
}


.maindiv{
    width: 100%;
    height: 100%;
    margin-top: 0px;
    margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/view/mobile/index.vue